"use client";

import { useEffect, useState } from "react";

import {
  GAM_BASE_TABLET_MID_AD_UNIT,
  GAM_BASE_TABLET_MID_ENABLED,
  GAM_BASE_TABLET_MID_MIN_HEIGHT,
  GAM_BASE_TABLET_MID_SIZES,
} from "@/components/ads/config";
import GamDisplaySlot from "@/components/ads/GamDisplaySlot";

import styles from "./BaseArticle.module.css";

type Props = {
  targeting?: Record<string, string | number | boolean | Array<string | number | boolean> | null | undefined>;
};

export default function BaseTabletMidBannerAd({ targeting }: Props) {
  const [isTablet, setIsTablet] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px) and (max-width: 1279px)");
    const update = () => setIsTablet(mediaQuery.matches);

    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (!GAM_BASE_TABLET_MID_ENABLED || isTablet !== true) return null;

  return (
    <div className={styles.bannerAdWrap} data-base-banner-device="tablet-mid">
      <div className={styles.bannerAdBox}>
        <div className={styles.adHeader}>
          <span className={styles.sponsored}>Sponsored</span>
        </div>

        <GamDisplaySlot
          id="base-tablet-mid-banner"
          adUnit={GAM_BASE_TABLET_MID_AD_UNIT}
          sizes={[...GAM_BASE_TABLET_MID_SIZES]}
          minHeight={GAM_BASE_TABLET_MID_MIN_HEIGHT}
          lazyRootMargin="700px 0px"
          targeting={{
            page_type: "base",
            device: "tablet",
            position: "after_strengths",
            placement: "base_tablet_mid_after_strengths",
            inventory_tier: "support_banner",
            ...targeting,
          }}
        />
      </div>
    </div>
  );
}
